import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  REMOTE_ASESETUP_FOLDERDELETE,
  REMOTE_ASESETUP_FOLDEROPEN,
  REMOTE_ASESETUP_OPENFOLDERSORDER,
} from 'store/actions';
import { selectAseSetupLibraryFolder } from 'store/remote/selectors';

type Props = {
  id: number;
  onPress: () => void;
  sectionCount: number;
  questionCount: number;
  checklistCount: number;
};

export const FolderListFolderListItem: React.FC<Props> = ({
  id,
  onPress,
  sectionCount,
  questionCount,
  checklistCount,
}) => {
  const dispatch = useDispatch();
  const folder = useSelector((state) => selectAseSetupLibraryFolder(state, id));

  if (!folder) {
    return null;
  }

  return (
    <CardRow
      icon={ICONS.FolderOpenLight}
      onPress={onPress}
      menuOptions={[
        {
          text: 'Open Folder',
          icon: ICONS.ChevronRightLight,
          onPress,
        },
        {
          text: 'Rename Folder',
          icon: ICONS.PencilLight,
          onPress: () => dispatch(REMOTE_ASESETUP_FOLDEROPEN({ id })),
        },
        {
          text: 'Reorder This',
          onPress: () => dispatch(REMOTE_ASESETUP_OPENFOLDERSORDER()),
          icon: ICONS.GripLinesLight,
        },
        {
          text: 'Delete Folder',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () => dispatch(REMOTE_ASESETUP_FOLDERDELETE({ id })),
        },
      ]}
      indentActions
    >
      <Txt size="small">{folder.name}</Txt>
      <Txt size="xxxsmall" style={{ color: theme.colors.fieldValueText }}>
        {pluralise(sectionCount, '1 Section', '{x} Sections', 'No Sections')}
        {' • '}
        {pluralise(
          questionCount,
          '1 Question',
          '{x} Questions',
          'No Questions',
        )}
        {' • '}
        {pluralise(
          checklistCount,
          '1 Checklist',
          '{x} Checklists',
          'No Checklists',
        )}
      </Txt>
    </CardRow>
  );
};
